<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Customer"
}
</script>

<style scoped>

</style>